// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider[data-v-e99027ae] {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n}", ""]);
// Exports
module.exports = exports;
